import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddContactComponent } from './add/add.component';
import { ApiService } from '../../services/api.service';
import { ContactService } from 'src/app/services/contact.service';
import { Subscription } from 'rxjs';
import { Contact, UserType } from '../../enums/constants';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.scss'],
    standalone: false
})
export class ContactsComponent implements OnInit, OnDestroy {
  list: any;
  appointees: string[] = [];
  designeeControl: string[] = [];
  otherContacts: string[] = [];
  appointeelength = 1;
  designeeControllength = 1;
  otherContactslength = 1;
  ContactEnum = Contact;
  private syncSubscription: Subscription;
  userType = UserType.USER;
  UserTypeEnum = UserType;

  @Input() parentEvent: {
    hide: (hide: boolean) => void,
    loading: (loading: boolean) => void,
  } = null;
  @Input() vaultUserForAdmin: any = null;

  constructor(
    private matDialog: MatDialog,
    private apiService: ApiService,
    private contactService: ContactService,
    private userService: UserService
  ) {
    this.list = [];
  }

  ngOnInit(): void {
    var self = this;
    self.userType = this.userService.usertype;
    self.designeeControl = self.apiService.designeeControl;
    self.otherContacts = self.apiService.contactsRoleNone;
    self.getList();
    self.getCardsMinimumData();

    this.syncSubscription = this.apiService.syncDataEvents$.subscribe(sync => {
      self.getList();
    });
  }

  ngOnDestroy(): void {
    this.syncSubscription?.unsubscribe();
  }

  getList() {
    var self = this;
    var reqparams = {};
    if (this.userType === UserType.ADMIN) {
      reqparams = { id: this.vaultUserForAdmin.id };
      this.parentEvent.loading(true);
    }

    this.apiService.getContacts(reqparams, {
      getResult(res) {
        self.apiService.allContacts = [];
        self.apiService.designeeControl = [];
        self.apiService.contactsRoleNone = [];

        res.data.forEach((contact) => {
          self.contactService.addToCachedContacts(contact);
        });

        self.designeeControl = self.apiService.designeeControl;
        self.otherContacts = self.apiService.contactsRoleNone;
        self.list = res.data;
        self.setLength();

        if (self.userType === UserType.ADMIN) {
          self.appointeelength = self.appointees.length;
          self.designeeControllength = self.designeeControl.length;
          self.otherContactslength = self.otherContacts.length;
          self.parentEvent.loading(false);
        }
      },
      getError(err) {
        console.log(err);
      },
    });
  }

  getCardsMinimumData() {
    let self = this;
    self.apiService.getCardsMinimumData({}, this.vaultUserForAdmin?.id, {
      getResult(res) {
        let cardsData = res.data;
        self.apiService.cardsMinimumData = cardsData;
      },
      getError(err) {
        console.log(err);
      }
    });
  }

  openAddContactModal(model) {
    var self = this;
    let dialogConfig: MatDialogConfig = {};
    dialogConfig.disableClose = true;
    if(model) {
      dialogConfig.data = { model: model };
    }

    if (this.userType === UserType.ADMIN) {
      dialogConfig.data = {
        ...dialogConfig.data,
        user: this.vaultUserForAdmin
      };
    }

    if (this.userType === UserType.ADMIN) {
      this.parentEvent.hide(true);
    }

    let dialogRef = this.matDialog.open(AddContactComponent, dialogConfig);
    let onSaveEventSubscription = dialogRef.componentInstance.onSaveEvent.subscribe((data) => {
      self.designeeControl = self.apiService.designeeControl;
      self.otherContacts = self.apiService.contactsRoleNone;
      self.setLength();
    });
    dialogRef.afterClosed().subscribe((value) => {
      this.getList();
      onSaveEventSubscription.unsubscribe();

      if (this.userType === UserType.ADMIN) {
        this.parentEvent.hide(false);
      }
    });
  }

  showAllAppointees() {
    if (this.appointeelength === 1) {
      this.appointeelength = this.appointees.length;
    } else {
      this.appointeelength = 1;
    }
  }

  showAllDesigneeControl() {
    if (this.designeeControllength === 1) {
      this.designeeControllength = this.designeeControl.length;
    } else {
      this.designeeControllength = 1;
    }
  }

  showAllOtherContacts() {
    if (this.otherContactslength === 1) {
      this.otherContactslength = this.otherContacts.length;
    } else {
      this.otherContactslength = 1;
    }
  }

  setLength() {
    if(this.appointeelength !== 1) {
      this.appointeelength = this.appointees.length;
    }
    if(this.designeeControllength !== 1) {
      this.designeeControllength = this.designeeControl.length;
    }
    if(this.otherContactslength !== 1) {
      this.otherContactslength = this.otherContacts.length;
    }
  }
}
